<template>
  <section class="table-section">
    <Breadcrumbs :crumbs="crumbs"/>
    <nav class="level">
      <!-- Left side -->
      <div class="level-left">
        <div class="level-item">
          <b-select v-model="defaultSortDirection">
            <option value="asc">Default sort: ASC</option>
            <option value="desc">Default sort: DESC</option>
          </b-select>
        </div>
        <div class="level-item">
          <b-select v-model="perPage" :disabled="!isPaginated">
            <option value="5">5 per page</option>
            <option value="10">10 per page</option>
            <option value="15">15 per page</option>
            <option value="20">20 per page</option>
          </b-select>
        </div>
        <div class="level-item">
          <div class="control is-flex">
            <b-switch v-model="isPaginated">Show Per Page</b-switch>
          </div>
        </div>
      </div>
      <!-- Right side -->
      <div class="level-right">
        <p class="level-item">
          <b-field horizontal label="Warehouse">
            <b-input
              v-model="startWh"
              custom-class="short-input"
              placeholder="From"
              type="text"
              icon="factory">
            </b-input>
            <b-input
              v-model="endWh"
              custom-class="short-input"
              placeholder="To"
              type="text"
              icon="factory">
            </b-input>
          </b-field>
        </p>
        <p class="level-item">
          <b-field grouped horizontal label="Item">
            <b-input
              v-model="startItem"
              custom-class="short-input"
              placeholder="From"
              type="text"
              icon="package-variant-closed">
            </b-input>
            <b-input
              v-model="endItem"
              custom-class="short-input"
              placeholder="To"
              type="text"
              icon="package-variant-closed">
            </b-input>
          </b-field>
        </p>
        <p class="level-item">
          <b-button icon-left="magnify" type="is-primary"
            @click="loadData">
            Search
          </b-button>
        </p>
      </div>
    </nav>
    <b-table
      class="table-fields"
      :data="data"
      :paginated="isPaginated"
      :per-page="perPage"
      :current-page.sync="currentPage"
      :default-sort-direction="defaultSortDirection"
      default-sort="ItemId"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :striped="true"
      :hoverable="true"
      :loading="isLoading"
    >
      <template slot-scope="props">
        <b-table-column
          field="ItemId"
          label="ID"
          width="50"
          sortable
        >{{ props.row.ItemId }}</b-table-column>
        <b-table-column
          field="ItemDescription"
          label="Description"
          sortable
        >{{ props.row.ItemDescription }}</b-table-column>
        <b-table-column
          field="Qty"
          label="Qty"
          width="50"
          sortable numeric
        >{{ props.row.Qty }}</b-table-column>
        <b-table-column
          field="WhseName"
          label="WhseName"
          sortable centered>
          {{ props.row.WhseName }} ({{ props.row.WhseId }})
        </b-table-column>
      </template>
    </b-table>
  </section>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs.vue';

export default {
  name: 'Sales',
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      data: [],
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: 'asc',
      currentPage: 1,
      perPage: 10,
      selected: {},
      isLoading: false,
      isCardModalActive: false,
      crumbs: [
        { title: 'Sales Summary', to: '/sales', active: true },
      ],
      details: {},
      startWh: '',
      endWh: '',
      startItem: '',
      endItem: '',
    };
  },
  methods: {
    loadData() {
      this.isLoading = true;
      const token = this.$store.state.accessToken.split('.');
      const user = atob(token[4]);
      const pass = atob(token[5]);
      const url = `ViewWhseStock?_username=${user}&_password=${pass}&_startingWhse=${this.startWh}&_endingWhse=${this.endWh}&_startingItem=${this.startItem}&_endingItem=${this.endItem}`;
      window.axios.post(url).then((r) => {
        this.isLoading = false;
        if (r.data.Result === 'TRUE') {
          this.data = r.data.TWhseStock;
        } else {
          this.$dialog.alert(r.data.Result);
        }
      }).catch((e) => {
        this.isLoading = false;
        this.$dialog.alert(e);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.table-section {
  padding: 1rem;
  .table-fields {
    padding: 1rem;
    background: #FFFFFF;
    border: 1px solid #cccccc;
  }
}
.modal-card-body {
  text-align: left;
  .field-body {
    -webkit-box-flex: 2;
    -ms-flex-positive: 2;
    flex-grow: 2;
    padding-top: 0.375em;
  }
}
</style>
